import React, { useEffect, useMemo, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SafariParkSearch from "../Home/SafariParkSearch";
import Parks from "./Parks";
import ParksFilter from "./ParksFilter";
import ParkMobileFilter from "./ParkMobileFilter";
import { useScreenSize } from "provider/ScreenSizeProvider";
import { useParksContext } from "provider/ParksProvider";
import { common } from "Data/common";


const AllParkLists = () => {
  const { parksData, pageIndex, summary, parksDispatch } = useParksContext();
  const { isMobileView } = useScreenSize();
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(false);
  const isFetchingRef = useRef(false);

  const PARK = common.ALL_PARKS;

  const handleFilterClick = () => {
    setShowFilter(true); // or toggle with !showFilter if you want toggle behavior
  };

  const processedParks = useMemo(() => {
    return parksData?.map((park) => ({
      ...park,
    }));
  }, [parksData, pageIndex]);


  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.innerHeight + window.scrollY;
      const threshold = document.body.offsetHeight - 500; // Trigger when 200px near bottom

      if (
        scrollPosition >= threshold &&
        !loading &&
        summary?.page < summary?.total_page &&
        !isFetchingRef.current
      ) {
        isFetchingRef.current = true; // Avoid multiple triggers
        parksDispatch({
          type: "SET_PAGE_INDEX",
          payload: pageIndex + 1,
        });
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [loading, pageIndex, summary?.page, summary?.total_page]);

  useEffect(() => {
    isFetchingRef.current = false;
  }, [parksData]);

  return (
    <>
      <section className="banner_section-inner  position-relative">
        <picture className="position-relative">
          <source
            srcSet="/img/baneer1719164625.jpg"
            media="(max-width:576px)"
            type="image/jpg"
          />
          <img
            src="/img/baneer1719164625.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
            type="image/jpg"
            loading="lazy"
          />
        </picture>
        <div className="banner_searchBox">
          <Container fluid="lg">
            <Row>
              <Col className="pt-2">
                <div className="tab-block" id="tab-block">
                  <div className="tab-cont">
                    <div className="tab-pane">
                      <SafariParkSearch />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <section className="articals_wrapper margin_bottomfooter mb-5 py-4">
        <Container fluid>
          <Row className="justify-content-center">
            <Col xl={10}>
              <Row>
                {!isMobileView && <Col
                  xl={2}
                  lg={2}
                  xs={12}
                  className="mb-lg-0 mb-3 filter-sidebar-sticky"
                >
                  <ParksFilter />
                </Col>
                }
                {isMobileView && <div
                  id="targetDiv"
                  className="mobileDive"
                  style={{ display: showFilter ? "block" : "none" }}
                >
                  <ParkMobileFilter onCancel={() => setShowFilter(false)} />
                </div>
                }
                {isMobileView && <Col xs={12} className="px-0 d-lg-none">
                  <div className="top_mobilefilter d-flex gap-2  justify-content-between align-items-center w-100 mb-4">
                    <div className="left_text">
                      <p className="mb-0">
                        {PARK?.PARK_TEXT_1}{" "}
                        <strong className="parklistcount">
                          {processedParks?.length} {PARK?.PARK_TEXT_2}
                        </strong>{" "}
                        {PARK?.PARK_TEXT_3}
                      </p>
                    </div>
                    <div className="right-select mobile_serach mb-md-0 ">
                      <div className="input_check pb-0">
                        <div className="filter_searchbox" onClick={handleFilterClick}>
                          <span> {PARK?.FILTER} <i className="fa-solid fa-chevron-down"></i></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
                }
                <Col lg={10} xl={10} xs={12} className="paddingset_desktop">
                  <Parks />
                </Col>
              </Row>

            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default AllParkLists;
